import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import DetailsChart from "@/components/governance/DetailsChart.vue";
import ProposalDetails from "@/components/governance/ProposalDetails.vue";
import ProposalDescription from "@/components/governance/ProposalDescription.vue";
import dataService from "@/services/data.service";
import router from "@/router";
import { useProposalsStore } from "@/store/proposals.store";
import Icon from "@/components/features/IconComponent.vue";
import ProposalAdditionalContent from "@/components/governance/ProposalAdditionalContent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GovernanceDetailsView',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();

onBeforeMount(() => {
  dataService.onProposalSelected(
    Number(route.params.id.toString()),
    () => {
      everythingIsReady.value = true;
    },
    () => {
      router.push({name: 'proposalsList'});
    }
  );
});

onUnmounted(() => {
  dataService.onProposalUnselected();
});

const proposal = computed(()=> {
  return useProposalsStore().getProposal;
});

const proposalDetailsTally = computed(()=> {
  return useProposalsStore().getProposalDetailsTally;
});
const everythingIsReady = ref(false);


const __returned__ = { route, proposal, proposalDetailsTally, everythingIsReady, DetailsChart, ProposalDetails, ProposalDescription, get router() { return router }, Icon, ProposalAdditionalContent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})